import routes from 'app/unsubscribe/routes';

export default {
  routes,
};
